import { Component } from 'react';

class SearchComponent extends Component {
    render() {
        let { _pageScope, moduleId, ...others } = this.props;
        return <div className='lowcode-search'>{_pageScope.props.search.NCCreateSearch(moduleId ?? others.items?.code, others)}</div>;
    }
}

export default SearchComponent;